(function(){
  var root=document.getElementById('baresupport-sale-native-final');
  if(!root) return;
  var defaultVariant='53385872343387';
  var offer=document.getElementById('cc-id-Jdm2X8SGztwK');
  function textOf(el){return ((el.getAttribute('data-text-value')||'')+' '+(el.textContent||'')+' '+(el.getAttribute('title')||'')).toLowerCase();}
  function selectorVariant(name){
    var box=root.querySelector('.odelise-size-selector[data-odelise-size-selector="'+name+'"]');
    var active=box && box.querySelector('.odelise-size-option.is-active');
    return (active && active.getAttribute('data-variant-id')) || defaultVariant;
  }
  function setActive(btn){
    var box=btn.closest('.odelise-size-selector');
    if(!box) return;
    box.querySelectorAll('.odelise-size-option').forEach(function(b){b.classList.toggle('is-active', b===btn);});
  }
  function checkout(btn){
    var qty=btn && (btn.getAttribute('data-checkout-qty') || (btn.getAttribute('data-offers')==='18801' ? '2' : '1'));
    if(qty==='2'){
      var first=selectorVariant('bundle-1');
      var second=selectorVariant('bundle-2');
      window.location.href = first===second ? '/cart/'+first+':2?checkout' : '/cart/'+first+':1,'+second+':1?checkout';
      return;
    }
    window.location.href='/cart/'+selectorVariant('single')+':1?checkout';
  }
  function setFaqHeight(item){
    var ans=item && item.querySelector('.faq-answer');
    if(!ans) return;
    ans.style.height=item.classList.contains('active') ? ans.scrollHeight+'px' : '0px';
  }
  root.querySelectorAll('.faq-item').forEach(function(item){ setFaqHeight(item); });
  window.addEventListener('resize',function(){root.querySelectorAll('.faq-item.active').forEach(setFaqHeight);});
  root.addEventListener('click',function(e){
    var sizeBtn=e.target.closest && e.target.closest('.odelise-size-option');
    if(sizeBtn && root.contains(sizeBtn)){
      e.preventDefault();
      setActive(sizeBtn);
      return;
    }
    var q=e.target.closest && e.target.closest('.faq-question');
    if(q && root.contains(q)){
      e.preventDefault();
      var item=q.closest('.faq-item');
      root.querySelectorAll('.faq-item').forEach(function(other){ if(other!==item){ other.classList.remove('active'); setFaqHeight(other); } });
      item.classList.toggle('active');
      setFaqHeight(item);
      return;
    }
    var el=e.target.closest && e.target.closest('a,button');
    if(!el || !root.contains(el)) return;
    if(el.classList.contains('addToCart') || el.getAttribute('data-checkout-qty')){
      e.preventDefault();
      checkout(el);
      return;
    }
    var txt=textOf(el);
    if(txt.indexOf('try')>-1 || txt.indexOf('order now')>-1 || txt.indexOf('56%')>-1 || txt.indexOf('today only')>-1){
      e.preventDefault();
      if(offer) offer.scrollIntoView({behavior:'smooth',block:'start'}); else window.location.href='/cart/'+defaultVariant+':1?checkout';
    }
  },true);
})();
